<template>
    <section class="slider">
        <slider-item v-for="(slide, index) in slides"
                    :key="index"
                    :ref="'slide_'+index"
                    :slide="slide"
                    :index="index"
                    :entering="slide.entering"
                    :leaving="slide.leaving"
                     @enterDone="slideEnteringComplete"
                     @leavingDone="slideLeavingComplete"
        ></slider-item>
        <div class="navigation">
            <div @click.prevent="prevSlide(true)" id="prev">
                <img src="/assets/img/slider-nav.svg">
            </div>
            <div @click.prevent="nextSlide(true)" id="next">
                <img src="/assets/img/slider-nav.svg">
            </div>
        </div>
        <scroll-indicator></scroll-indicator>
    </section>
</template>
<script>
    import SliderItem from './SliderItem'
    import Timer from './../Classes/Timer'

    export default {
        components: {
            SliderItem
        },
        data() {
            return {
                slides: [
                    {
                        active: true,
                        content: `<h2>${this.$t('slider.slide1.title')}</h2>
                                    <p>${this.$t('slider.slide1.content')}</p>`,
                        entering: false,
                        leaving: false,
                        direction: 1
                    },
                    {
                        active: false,
                        content: `<h2>${this.$t('slider.slide3.title')}</h2>
                                    <p>${this.$t('slider.slide3.content')}</p>`,
                        entering: false,
                        leaving: false,
                        direction: 1
                    },
                    {
                        active: false,
                        content: `<h2>${this.$t('slider.slide2.title')}</h2>
                                    <p>${this.$t('slider.slide2.content')}</p>`,
                        entering: false,
                        leaving: false,
                        direction: 1
                    }
                ],
                timer: null,
                current: 0,
                next: 1,
                animating: false,
                reset: false
            }
        },
        mounted() {
            this.start()
        },
        methods: {
            start() {
                this.timer = new Timer( this.nextSlide, 5, this ).start()
            },
            slideEnteringComplete( index, direction ) {
                this.slides[index].active = true;
                this.slides[index].entering = false;

                if( this.reset ) this.timer.reset()
                this.reset = false

                if( direction === 1 ) return this.incrementToMax( 'next' )

                this.slides[index].direction = 1;
                this.incrementToMax( 'next')
            },
            slideLeavingComplete( index, direction ) {
                this.slides[index].active = false;
                this.slides[index].leaving = false;

                if( direction === 1 ) return this.incrementToMax( 'current' )

                this.slides[index].direction = 1;
                this.decrementToMin('current')
            },
            incrementToMax( key, value = 1 ) {
                this[key] += value
                if( this[key] === this.slides.length ) this[key] = 0
            },
            decrementToMin( key, value = 1) {
                this[key] -= value

                if( this[key] < 0 ) this[key] = this.slides.length - 1
            },
            nextSlide( reset = false ) {
                this.slides[this.current].leaving = true
                this.slides[this.next].entering = true
                this.reset = reset
            },
            prevSlide( reset = false ) {
                this.next = this.current - 1;
                if( this.next < 0 ) this.next = this.slides.length - 1;

                this.slides[this.current].direction = -1;
                this.slides[this.next].direction = -1;

                this.slides[this.current].leaving = true;
                this.slides[this.next].entering = true;
                this.reset = reset
            }
        }
    }
</script>